import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RUTA_SERVICIOS_ENTRENAMIENTO } from "../../../services/rutas";
import { ItemListadoServiciosEntrenamiento } from "../../../services/entrenamientoServicios";


function Table({ items }: TableSectionProps) {
    return (
        <StyledTable responsive hover>
            <thead>
                <tr>
                    <StyledColHeader>Nombre</StyledColHeader>
                    <StyledColHeader>Sesiones</StyledColHeader>
                    <StyledColHeader>Precio Total</StyledColHeader>
                    <StyledColHeader>Descripción</StyledColHeader>
                </tr>
            </thead>
            <tbody>
                {
                    items.map((_, index) => <TableItem key={_.id} item={_}/>)
                }
            </tbody>
        </StyledTable>
    );
}

interface TableSectionProps {
    items: ItemListadoServiciosEntrenamiento[]
}

interface TableItemProps {
    item: ItemListadoServiciosEntrenamiento
}

function TableItem({ item }: TableItemProps){
    let navigate = useNavigate();
    const currencyFormat = new Intl.NumberFormat('es-CO', currencyFormatOptions);

    return (
        <StyledRow onClick={() => navigate(`${RUTA_SERVICIOS_ENTRENAMIENTO}/${item.id}`, { replace: false })}>
            <StyledCell>{item.nombre}</StyledCell>
            <StyledCell>{item.numeroSesiones}</StyledCell>
            <StyledCell>{currencyFormat.format(item.precioTotal)}</StyledCell>
            <StyledCell>{item.descripcion}</StyledCell>
        </StyledRow>
    );
}

const currencyFormatOptions: any = { style: 'currency', currency: 'COP' }

const StyledTable = styled(BsTable)`

`

const StyledCell = styled("td")`

`

const StyledColHeader = styled("th")`
    color: ${props => props.theme.colors.main};
`

const StyledRow = styled("tr")`
    cursor: pointer;
`

export default Table;